const n = (t, s) => !t || s === "_top" || s === "_self" ? !1 : s === "_blank" ? !0 : (t = t.trim(), t.startsWith("http://") || t.startsWith("https://") || t.startsWith("//") || t.startsWith("mailto:") || t.startsWith("tel:") || t.startsWith("www")), e = /\?epslanguage=\w{2}/, a = [e], i = (t) => {
  for (const s of a)
    t = t.replace(s, "");
  return t;
};
export {
  i as cleanUrl,
  n as isOrHandleAsExternalUrl
};
